import React, { Component, forwardRef } from 'react';
import { Link, Redirect } from 'react-router-dom';
import MaterialTable from 'material-table';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Loader from '../../../Loader.js';
import Form from 'react-bootstrap/Form';
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Button from '@material-ui/core/Button';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { LocalizationTheme } from '../../../../utils/utils.js';
import { DisplayMessage, GetDayOfWeekName } from '../../../../services/helpers.js';
import FontDownloadRoundedIcon from '@material-ui/icons/FontDownloadRounded';
import FileCopyIcon from '@material-ui/icons/FileCopy';

import { sortTableBooleans, sortTableDates, sortTableNumbers } from '../../../../utils/tableSorting.js';
import appFetch from '../../../../api/appFetch.js';
import { MoboOutletOpeningHoursUrl, MoboOutletOpeningHoursByOutletIdUrl, MoboOutletOpeningHoursWithIdUrl } from '../../../../constants/apiUrls.js';

import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';
import DaysOfWeekDropdown from '../../../Common/Dropdowns/DaysOfWeekDropdown.js';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    FontDownloadRoundedIcon: forwardRef((props, ref) => <FontDownloadRoundedIcon {...props} ref={ref} />)
};

export default class OpeningHoursTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dataGrid: [],
            outletId: this.props.outletId ?? this.props.accessibleMoboOutlets[0]?.id ?? 0,
            fetchingData: true,
            showDelete: false,
            showCopy: false,
            deletedItem: 0,
            copiedOpeningHour: undefined,
            accessibleMoboOutlets: [],
            editedOpeningHourId: undefined,
            editedOpeningHour: undefined,
            showEditOpeningHour: false,
            requestInProgress: false,
            copiedDayOfWeek: 0,
            daysOfWeek: [],
            checkedForData: false,
            openingHours: [],

        };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.refreshGrid && newProps.outletId) {
            this.getData(newProps.outletId);
        }

        this.setState({ redirect: null });
    }

    componentDidMount() {
        this.getData(this.state.outletId);
    }

    handleChangeOutlet = e => {
        this.setState({ outletId: e.target.value, copiedOutletId: 0 }, () => this.getData(this.state.outletId));
    };

    handleChangeCopiedDayOfWeek = e => {
        this.setState({ copiedDayOfWeek: e.target.value });
    };

    getData = (outlet) => {
        if (outlet === undefined || outlet === "") {
            var outlets = this.props.accessibleMoboOutlets.sort((a, b) => (a.description > b.description) ? 1 : -1)
            if (this.props.accessibleMoboOutlets === undefined) { 
                return; 
            }

            outlet = this.state.outletId > 0 ? this.state.outletId : outlets[0].id;
        }

        this.setState({ fetchingData: true });

        let initialData = {};
        var resources = this.props.resources;
        initialData.columns = [
            {
                title: resources["Day"],
                field: 'dayOfWeek',
                width: "20%",
                options: { filter: true, sort: true },
                customSort: (a, b) => sortTableNumbers(a.dayOfWeekNumber, b.dayOfWeekNumber)
            },
            {
                title: resources["OpenFrom"],
                field: 'workshopOpenFrom',
                width: "20%",
                options: { filter: true, sort: true },
                customSort: (a, b) => sortTableDates(a.workshopOpenFrom, b.workshopOpenFrom, "HH:mm")
            },
            {
                title: resources["OpenTill"],
                field: 'workshopOpenTill',
                width: "20%",
                options: { filter: true, sort: true },
                customSort: (a, b) => sortTableDates(a.workshopOpenTill, b.workshopOpenTill, "HH:mm")
            },
            { 
                title: resources["IsWorkshopClosed"],
                field: 'isWorkshopClosed',
                width: "20%",
                options: { filter: true, sort: true },
                render: rowData => rowData.isWorkshopClosed ? resources["Yes"] : resources["No"],
                customSort: (a, b) => sortTableBooleans(a.isWorkshopClosed, b.isWorkshopClosed)
            },
        ];

        initialData.actions = [
            {
                icon: () => <Edit />,
                tooltip: resources["Edit"],
                onClick: (event, rowData) => this.setState({ redirect: `openinghours/${rowData.moboOutletId}/${rowData.id}`, editedOpeningHourId: rowData.id })
            },
            {
                icon: () => <DeleteOutline />,
                tooltip: resources["Delete"],
                onClick: (event, rowData) => this.handleShowDelete(rowData.id)
            },

            rowData => (this.state.dataGrid.data !== undefined && this.state.dataGrid.data.length !== 7 ? {
                icon: () => <FileCopyIcon />,
                tooltip: resources["Copy"],
                onClick: (event, rowData) => this.handleShowCopy(rowData)
            } : null),
        ]

        appFetch({
            url: MoboOutletOpeningHoursByOutletIdUrl(outlet),
            onSuccess: (data) => {
                const currentRows = [];
                const openingHours = [];
                var daysOfWeek = [];
                data.forEach(function (rowData) {
                    openingHours.push(rowData);
                    daysOfWeek.push(rowData.dayOfWeek);
                    var dayOfWeekName = GetDayOfWeekName(rowData.dayOfWeek, resources);
                    currentRows.push({
                        id: rowData.id,
                        dayOfWeek: dayOfWeekName,
                        dayOfWeekNumber: rowData.dayOfWeek,
                        moboOutletId: rowData.moboOutletId,

                        workshopOpenFrom: rowData.workshopOpenFrom,
                        workshopOpenTill: rowData.workshopOpenTill,

                        workshopDropFrom: rowData.workshopDropFrom,
                        workshopDropTill: rowData.workshopDropTill,

                        workshopDropCloseNoonFrom: rowData.workshopDropCloseNoonFrom,
                        workshopDropCloseNoonTill: rowData.workshopDropCloseNoonTill,

                        onlineOpenFrom: rowData.onlineOpenFrom,
                        onlineOpenTill: rowData.onlineOpenTill,

                        isWorkshopClosed: rowData.isWorkshopClosed,
                    });
                });

                var filteredData = currentRows.sort((a, b) => (a.dayOfWeekNumber > b.dayOfWeekNumber) ? 1 : -1)

                initialData.data = filteredData;
                
                var availableDays = [...Array(7).keys()].filter(day => daysOfWeek.indexOf(day) < 0);
                this.setState({
                    daysOfWeek: daysOfWeek,
                    copiedDayOfWeek: availableDays.length > 0 ? availableDays[0] : 0,
                    dataGrid: initialData,
                    openingHours: openingHours,
                    checkedForData: true,
                    outletId: parseInt(outlet)
                });
            },
            onError: (data) => {
                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ fetchingData: false });
            }
        })
    }

    handleCloseDelete = () => {
        this.setState({ showDelete: false, deletedItem: undefined });
    }

    handleCloseCopy = () => {
        this.setState({ showCopy: false, copiedOpeningHour: undefined, copiedDescription: "" });
    }

    handleShowDelete = (itemId) => {
        this.setState({ showDelete: true, deletedItem: itemId });
    }

    handleShowCopy = (item) => {
        this.setState({ showCopy: true, copiedOpeningHour: item, copiedDescription: item.dayOfWeek });
    }

    handleDeleteOpeningHour = () => {
        if (this.state.deletedItem > 0) {
            let resources = this.props.resources;
            this.setState({ requestInProgress: true });
            const url = MoboOutletOpeningHoursByOutletIdUrl(this.state.deletedItem);

            appFetch({
                url: url,
                method: 'DELETE',
                onSuccess: () => {
                    DisplayMessage(resources["OpeningHourWasDeleted"], "success");
                    this.getData(this.state.outletId);
                    this.setState({ showDelete: false, deletedItem: 0 });
                    this.handleCloseDelete();
                },
                onError: (data, response) => {
                    if (response.statusText.length > 0) {
                        DisplayMessage(response.statusText, "error");
                    }

                    for (var i = 0; i < data.errors.length; i++) {
                        DisplayMessage(data.errors[i], "error");
                    }
                },
                onFinalize: () => {
                    this.setState({ requestInProgress: false });
                }
            })
        }
    }

    handleCopyOpeningHour = () => {
        if (this.state.copiedOpeningHour === undefined) { 
            return; 
        }

        this.setState({ requestInProgress: true });
        let resources = this.props.resources;

        var copiedOpeningHour = this.state.copiedOpeningHour;
        // Fetch by copiedOpeningHour on  /api/mobopro/v1/mobooutletopeninghours
        // Then, on succes make post call
        appFetch({
            url: MoboOutletOpeningHoursWithIdUrl(copiedOpeningHour.id),
            onSuccess: (rowData) => {
                var json = JSON.stringify({
                    workshopOpenFrom: rowData.workshopOpenFrom === null ? "08:00" : rowData.workshopOpenFrom,
                    workshopOpenTill: rowData.workshopOpenTill === null ? "17:00" : rowData.workshopOpenTill,
                    workshopDropFrom: rowData.workshopDropFrom === null ? "08:00" : rowData.workshopDropFrom,
                    workshopDropTill: rowData.workshopDropTill === null ? "16:00" : rowData.workshopDropTill,
                    workshopDropCloseNoonFrom: rowData.workshopDropCloseNoonFrom,
                    workshopDropCloseNoonTill: rowData.workshopDropCloseNoonTill,
                    onlineOpenFrom: rowData.onlineOpenFrom,
                    onlineOpenTill: rowData.onlineOpenTill,
                    isWorkshopClosed: rowData.isWorkshopClosed,
                    dayOfWeek: this.state.copiedDayOfWeek,
                    moboOutletId: rowData.moboOutletId,
                    defaultDropTime: rowData.defaultDropTime,
                    defaultEndOfDayTime: rowData.defaultEndOfDayTime
                });
        
                appFetch({
                    url: MoboOutletOpeningHoursUrl(),
                    method: 'POST',
                    body: json,
                    onSuccess: () => {
                        this.setState({
                            updateInProgress: false,
                            openingHourWasCreated: true,
                            redirect: "/openinghours",
                            showCopy: false,
                            copiedOpeningHour: undefined,
                            copiedDescription: "",
                            copiedDayOfWeek: "",
                        }, () => this.getData());
        
                        DisplayMessage(resources["OpeningHourWasCopied"], "success");
                    },
                    onError: (data) => {
                        for (let i = 0; i < data.errors.length; i++) {
                            DisplayMessage(data.errors[i], "error");
                        }
                    },
                    onFinalize: () => {
                        this.setState({ requestInProgress: false });
                    }
                });
            },
            onError: (data) => {
                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        });
    }

    render() {
        const { redirect, fetchingData, dataGrid, outletId } = this.state;
        const { resources } = this.props;
        const displayAddButton = dataGrid.data === undefined || dataGrid.data.length < 7 ? "block" : "none";


        if (redirect) { 
            return <Redirect to={{ pathname: redirect, state: { editedOpeningHour: this.state.editedOpeningHour, outletId: this.state.outletId, refreshGrid: true } }} /> 
        }

        return (
            <div>
                <div className="position-relative py-4">
                    <h3>{resources["OpeningHours"]}</h3>
                    <div className={"offcentered-loader " + (fetchingData ? 'fadeIn' : 'fadeOut')}><CircularProgress /></div>
                    <div className={"mt-4 " + (fetchingData ? 'fadeOut' : 'fadeIn')}>
                        <Form.Group className="main-dropdown">
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={outletId}
                            onOutletChange={this.handleChangeOutlet}
                            containerClass="col-md-12"
                            id="outlet-dropdown-grid"
                            defaultValue={null}
                            noPlaceholder
                        />
                        </Form.Group>
                        <div style={{ float: "right", marginBottom: "10px", display: displayAddButton }}>
                            <Link to={{ pathname: `/openinghours/new`, state: { outletId: this.state.outletId } }} style={{ textDecoration: 'none' }}>
                                <Button id="add-OpeningHour" variant="contained" color="primary">
                                    <i className="fas fa-plus mr-2" title={resources["AddNewOpeningHour"]} />
                                    {resources["AddNewOpeningHour"]}
                                </Button>
                            </Link >
                        </div>
                        <div style={{ clear: "both", }}></div>

                        <Paper elevation={3} className="p-3 mt-3">
                            <MuiThemeProvider theme={LocalizationTheme()}>
                                <MaterialTable
                                    icons={tableIcons}
                                    title={""}
                                    localization={{
                                        header: { actions: resources["Actions"] },
                                        body: {
                                            emptyDataSourceMessage: resources["NoRecordsToBeDisplayed"],
                                            deleteTooltip: resources["DeleteTooltip"],
                                            editTooltip: resources["EditTooltip"],
                                        },
                                        toolbar: {
                                            searchPlaceholder: resources["Search"],
                                            searchTooltip: resources["Search"]
                                        },
                                        pagination: {
                                            firstTooltip: resources["FirstTooltip"],
                                            lastTooltip: resources["LastTooltip"],

                                            previousTooltip: resources["PreviousTooltip"],
                                            nextTooltip: resources["NextTooltip"],

                                            labelRowsPerPage: resources["LabelRowsPerPage"],
                                            labelRowsSelect: resources["LabelRowsSelect"],
                                        }
                                    }}
                                    data={this.state.dataGrid.data}
                                    columns={this.state.dataGrid.columns}
                                    actions={this.state.dataGrid.actions}
                                    options={{ emptyRowsWhenPaging: false, pageSize: 10, pageSizeOptions: [10, 15, 20] }}
                                />
                            </MuiThemeProvider>
                        </Paper>
                    </div>
                    <div className={"loader-overlap position-absolute " + (this.state.fetchingData ? 'fadeIn' : 'fadeOut')}><div className="container"><Loader /></div></div>

                    <Rodal visible={this.state.showDelete} onClose={this.handleCloseDelete} className="rodal" customStyles={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'
                    }}>
                        <div className="modal-body" style={{ marginTop: "20px", display: "flex", alignItems: "center" }}>{resources["AreYouSureYouWantToDeleteOpeningHour"]}</div>
                        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                            <button className="btn btn-secondary" id="btnCancelDelete" style={{ backgroundColor: "white", color: "#53B3EA", borderColor: "#53B3EA" }}
                                onClick={this.handleCloseDelete} disabled={this.state.requestInProgress}>{resources["Cancel"]}</button>
                            <button className="btn btn-primary" id="btnDelete" style={{ backgroundColor: "#53B3EA", color: "white", borderColor: "#53B3EA" }}
                                onClick={this.handleDeleteOpeningHour} disabled={this.state.requestInProgress}>{resources["Yes"]}</button>

                        </div>
                        <span className="rodal-close"></span>
                    </Rodal>

                    <Rodal visible={this.state.showCopy} onClose={this.handleCloseCopy} className="rodal" style={{ height: "350px!important" }} >

                        <div className="modal-body" >{resources["CopyOpeningHour"]}</div>
                        <Form.Group style={{ display: "flex" }}>
                            <Form.Label className="col-md-3 text-left label-mt my-auto" >{resources["From"]}:  </Form.Label>
                            <Form.Label className="col-md-6 text-left label-mt my-auto pl-0 form-label" >{this.state.copiedDescription}  </Form.Label>
                        </Form.Group>

                        <Form.Group style={{ display: "flex" }}>
                            <Form.Label className="col-md-3 text-left label-mt my-auto" >{resources["To"]}:  </Form.Label>
                            <DaysOfWeekDropdown 
                                resources={resources}
                                dayOfWeek={this.state.copiedDayOfWeek}
                                onDayOfWeekChange={this.handleChangeCopiedDayOfWeek}
                                filter={(day) => this.state.daysOfWeek.indexOf(day) < 0}
                                containerClass="col-md-4"
                                id="dayofweek-dropdown-grid"
                            />
                        </Form.Group>

                        <div className="modal-footer" style={{ borderTop: "1px solid white" }}>
                            <button className="btn btn-secondary" id="btnCancelCopy" style={{ backgroundColor: "white", color: "#53B3EA", borderColor: "#53B3EA" }}
                                onClick={this.handleCloseCopy} disabled={this.state.requestInProgress}>{resources["Cancel"]}</button>
                            <button className="btn btn-primary" id="btnCopy" style={{ backgroundColor: "#53B3EA", color: "white", borderColor: "#53B3EA" }}
                                onClick={this.handleCopyOpeningHour} disabled={this.state.requestInProgress}>{resources["Save"]}</button>
                        </div>
                        <span className="rodal-close"></span>
                    </Rodal>
                </div>
            </div >
        )
    };
}